import { TradingViewTimeframesEnum } from '@modules/trading-view-module/enums/trading-view-timeframes.enum'
import { ResolutionMapType } from '@modules/trading-view-module/types/resolution-map.type'

export const ResolutionMap: ResolutionMapType = {
	[TradingViewTimeframesEnum.oneMinute]: { multiplier: 1, timespan: 'minute' },
	[TradingViewTimeframesEnum.threeMinutes]: { multiplier: 3, timespan: 'minute' },
	[TradingViewTimeframesEnum.fiveMinutes]: { multiplier: 5, timespan: 'minute' },
	[TradingViewTimeframesEnum.fifteenMinutes]: { multiplier: 15, timespan: 'minute' },
	[TradingViewTimeframesEnum.thirtyMinutes]: { multiplier: 30, timespan: 'minute' },
	[TradingViewTimeframesEnum.oneHour]: { multiplier: 1, timespan: 'hour' },
	[TradingViewTimeframesEnum.twoHours]: { multiplier: 2, timespan: 'hour' },
	[TradingViewTimeframesEnum.threeHours]: { multiplier: 3, timespan: 'hour' },
	[TradingViewTimeframesEnum.fourHours]: { multiplier: 4, timespan: 'hour' },
	[TradingViewTimeframesEnum.oneDay]: { multiplier: 1, timespan: 'day' },
	[TradingViewTimeframesEnum.oneWeek]: { multiplier: 1, timespan: 'week' },
	[TradingViewTimeframesEnum.oneMonth]: { multiplier: 1, timespan: 'month' },
	[TradingViewTimeframesEnum.oneYear]: { multiplier: 1, timespan: 'year' },
}
